package com.macrofocus.nastac.components

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.nastac.ViewStyle
import emotion.react.css
import i18next.useTranslation
import mui.material.ListItemButton
import mui.material.ListItemIcon
import mui.material.ListItemText
import mui.system.sx
import org.mkui.react.toState
import react.FC
import react.PropsWithChildren
import react.ReactNode
import react.dom.events.MouseEvent
import react.dom.html.ReactHTML.div
import web.cssom.Color
import web.cssom.None
import web.cssom.WhiteSpace
import web.cssom.px
import web.html.HTMLElement

external interface ViewStyleLinksProps : PropsWithChildren {
    var viewStyleProbing: MutableProperty<ViewStyle?>
    var viewStyleSelection: MutableProperty<ViewStyle>
}

val ViewStyleLinks = FC<ViewStyleLinksProps> { props ->
    val (t, _) = useTranslation()

    val (viewStyle, setViewStyle) = props.viewStyleSelection.toState()

    mui.material.List {
        dense = true
        sx {
            padding = 0.px
//            width = Sizes.Fabbar.Width
        }

        for (v in ViewStyle.entries) {
            if(v.visible) {
                div {
    //            to = "flow"

                    css {
                        textDecoration = None.none
                        color = Color.currentColor
                    }

                    ListItemButton {
                        key = v.toString()
                        //                                selected = lastPathname == key
                        selected = viewStyle == v
                        disabled = !v.isEnabled(viewStyle)

                        onClick = { event: MouseEvent<HTMLElement, *> ->
                            setViewStyle(v)
                        }

                        onMouseEnter = { event: MouseEvent<HTMLElement, *> ->
                            props.viewStyleProbing.value = v
                        }

                        onMouseEnter = { event: MouseEvent<HTMLElement, *> ->
                            props.viewStyleProbing.value = null
                        }

                        ListItemIcon {
                            v.icon {
                            }
                        }
                        ListItemText {
                            sx {
                                whiteSpace = WhiteSpace.nowrap
                            }
                            primary = ReactNode(v.toString())
                        }
                    }
                }
            }
        }
    }
}